//Imports
import React, { useContext, useState } from "react";
import Select, { components } from 'react-select';
import { doc, setDoc } from "firebase/firestore";
import { db, firebaseConfig } from "../../../firebase";
import { createUserWithEmailAndPassword, getAuth } from "firebase/auth";
import firebase from "firebase/compat/app";
//Imports contexts
import { AppContext } from "../../../contexts/AppContext";
import { AuthContext } from "../../../contexts/AuthContext";
import staticData from '../../../contexts/staticData.json';
//Imports icons
import downArrow from '../../../assets/icons/downArrow.svg';
import downArrowWhite from '../../../assets/icons/downArrowWhite.svg';
import visible from '../../../assets/icons/visible.svg';
import notVisible from '../../../assets/icons/notVisible.svg';
import addUser from '../../../assets/icons/addUser.svg';
import user from '../../../assets/icons/user.svg';
//Imports CSS
import './addUserForm.css';


function AddUserForm({ onClose, show, projectId }) {
    const { establishmentList } = useContext(AppContext);
    const { userData } = useContext(AuthContext);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [dimension, setDimension] = useState(null);
    const [emailError, setEmailError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
    const [inputPhone, setInputPhone] = useState('');
    const [selectedEstablishment, setSelectedEstablishment] = useState(null);
    const [formError, setFormError] = useState(null);
    const [isAdminHolder, setIsAdminHolder] = useState(false);

    const filteredEstablishment = establishmentList?.filter((establishment) => establishment.projectId === projectId);

    const handleSelect = (selectedOption) => {
        setDimension(selectedOption.value)
        if (selectedOption.value !== 'Sostenedor') {
            setIsAdminHolder(false);
        }
    };

    const handlePhoneChange = (e) => {
        let numbers = e.target.value.replace(/\D/g, '');
    
        if (numbers.startsWith('56')) {
            numbers = numbers.substring(2);
        }
    
        numbers = numbers.substring(0, 9);
        // Formatear con el prefijo +56
        const formattedNumber = numbers ? `+56${numbers}` : '';
        setInputPhone(formattedNumber);
    };

    const handleEstablishmentSelect = (selectedOption) => {
        setSelectedEstablishment(selectedOption);
    };

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleEmailChange = (e) => {
        if (!validateEmail(email.value)) {
            setEmailError(true);
        } else {
            setEmailError(false);
        }
    };

    const handlePasswordChange = (e) => {
        if (e.target.value.length < 6) {
            setPasswordError(true)
        } else {
            setPasswordError(false);
        }
    }


    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const { email, password, displayName, dimension, department, state } = event.target;
            
            // Inicializar la aplicación secundaria
            const secondaryApp = firebase.initializeApp(firebaseConfig, 'secondary');
            const secondaryAuth = getAuth(secondaryApp);
            
            // Crear usuario en Firebase Authentication (pero aún no confirmamos éxito)
            const userCredential = await createUserWithEmailAndPassword(secondaryAuth, email.value, password.value);
            const newUser = userCredential.user;
            
            // Preparar los datos para guardar en Firestore
            const userData = {
                uid: newUser.uid,
                displayName: displayName.value,
                email: email.value,
                phoneNumber: inputPhone || '',  // Usar string vacío si es null
                dimension: dimension.value,
                department: department.value,
                state: state.value,
                tenantId: projectId,
                permissions: dimension.value === 'Sostenedor' && isAdminHolder ? 'admin-holder' : null,
            };
            
            if (selectedEstablishment) {
                userData.establishment = selectedEstablishment.label;
                userData.establishmentId = selectedEstablishment.value;
            }
            
            try {
                // Intentar guardar en Firestore
                await setDoc(doc(db, 'users', newUser.uid), userData);
                console.log("Nuevo usuario creado con éxito:", newUser.uid);
                
                // Si llegamos aquí, todo salió bien
                secondaryAuth.signOut();
                secondaryApp.delete();
                onClose(true);
            } catch (firestoreError) {
                // Si falla al guardar en Firestore, eliminar el usuario de Authentication
                console.error('Error al guardar usuario en Firestore:', firestoreError);
                
                try {
                    // Eliminar el usuario de Authentication ya que no pudimos guardarlo en Firestore
                    await newUser.delete();
                    console.log("Usuario eliminado de Authentication debido a error en Firestore");
                } catch (deleteError) {
                    console.error('Error al eliminar usuario de Authentication:', deleteError);
                }
                
                setFormError(`Error al guardar en la base de datos: ${firestoreError.message}`);
                
                // Limpiar recursos
                secondaryAuth.signOut();
                secondaryApp.delete();
            }
        } catch (authError) {
            // Error al crear usuario en Authentication
            console.error('Error al crear usuario en Authentication:', authError);
            setFormError(`Error al crear cuenta: ${authError.message}`);
        }
    };

    return (
        <form className={`container-form-add-project flex ${show ? 'show' : 'hidden'}`} onSubmit={handleSubmit} >
            <div className='container flex'>
                <article className='first-box flex'>
                    <span className='input-select dimension-select'>
                        <label htmlFor='dimension' className='label-hidden'>Dependencia</label>
                        <Select
                            name='dimension'
                            id='dimension'
                            options={staticData.dimension.map((dimension) => ({
                                value: dimension,
                                label: dimension
                            }))}
                            placeholder='Selecciona dimensión'
                            className='custom-select'
                            classNamePrefix='custom-select'
                            components={{ DropdownIndicator }}
                            value={dimension ? { value: dimension, label: dimension } : null}
                            onChange={handleSelect}
                        />
                    </span>
                    <span className='input-box'>
                        <label htmlFor='displayName' className='label'>Nombre de Usuario</label>
                        <input
                            type='text'
                            id='displayName'
                            name='displayName'
                            className='input'
                            placeholder='Ingrese nombre del nuevo usuario'
                        />
                    </span>
                    <span className='input-box'>
                        <label htmlFor='phoneNumber' className='label'>Contacto</label>
                        <input
                            type='tel'
                            id='phoneNumber'
                            name='phoneNumber'
                            className='input'
                            placeholder='Ej: +56XXXXXXXXX'
                            value={inputPhone}
                            onChange={handlePhoneChange}
                            maxLength='12'
                        />
                    </span>
                </article>
                <article className='second-box flex'>
                    <div className='box-photo flex'>
                        <img src={user} className='icon' alt='Icono de foto de usuario' />
                    </div>
                </article>
            </div>
            <aside className='box-variable flex'>
                <span className='input-select'>
                    <label htmlFor='state' className='label'>Estado</label>
                    <Select
                        name='state'
                        id='state'
                        options={staticData.states.map((state) => ({
                            value: state,
                            label: state
                        }))}
                        placeholder='Selecciona estado'
                        className='custom-select'
                        classNamePrefix='custom-select'
                        components={{ DropdownIndicator2 }}
                    />
                </span>
                {dimension === 'Sostenedor' ? (
                    <span className='input-select department-select flex'>
                        <label htmlFor='state' className='label'>Departamento de Administración</label>
                        <Select
                            name='department'
                            id='department'
                            options={staticData.departments.map((department) => ({
                                value: department,
                                label: department
                            }))}
                            placeholder='Selecciona estado'
                            className='custom-select'
                            classNamePrefix='custom-select'
                            components={{ DropdownIndicator2 }}
                        />
                        {userData?.permissions === 'admin' && (
                            <span className='input-checkbox flex'>
                                <label htmlFor='permissions' className='input-check-label flex'><p>Permisos de Administrador</p></label>
                                <input
                                    type='checkbox'
                                    name='permissions'
                                    checked={isAdminHolder}
                                    onChange={(e) => setIsAdminHolder(e.target.checked)}
                                    className='input-check flex'
                                />
                            </span>
                        )}
                    </span>
                ) : (dimension === 'Establecimiento' &&
                    <>
                        <span className='input-select'>
                            <label htmlFor='state' className='label'>Establecimiento</label>
                            <Select
                                name='establishment'
                                id='establishment'
                                options={filteredEstablishment.map((establishment) => ({
                                    value: establishment.id,
                                    label: establishment.nameEstablishment
                                }))}
                                placeholder='Selecciona estado'
                                className='custom-select'
                                classNamePrefix='custom-select'
                                value={selectedEstablishment}
                                onChange={handleEstablishmentSelect}
                                components={{ DropdownIndicator2 }}
                            />
                        </span>
                        <span className='input-box'>
                            <label htmlFor='displayName' className='label'>Cargo</label>
                            <input
                                type='text'
                                id='department'
                                name='department'
                                className='input'
                                placeholder='Ingrese cargo'
                            />
                        </span>
                    </>
                )}

            </aside>
            <article className='third-box flex'>
                <span className='input-box'>
                    <label htmlFor='email' className='label'>Usuario</label>
                    <input
                        type='email'
                        id='email'
                        name='email'
                        className='input'
                        placeholder='Ingrese correo de usuario'
                        onChange={handleEmailChange}
                    />
                    {emailError && <p className='error-message'>Por favor, ingresa un correo electrónico válido.</p>}
                </span>
                <span className='input-box'>
                    <label htmlFor='password' className='label'>Contraseña</label>
                    <span className='input-password flex'>
                        <input type={passwordVisible ? 'text' : 'password'} id="password" name="password" className='input-email password' placeholder='Ingresa contraseña' onChange={handlePasswordChange} />
                        <img src={passwordVisible ? notVisible : visible} alt='Icono para dar visibilidad a contraseña' className='icon-input' onClick={() => setPasswordVisible(!passwordVisible)} />
                    </span>
                    {passwordError && <p className='error-message'>La contraseña debe tener al menos 6 caracteres.</p>}
                </span>
            </article>
            {formError && <p className="error-message">{`Error al ingresar nuevo usuario: ${formError}`}</p>}
            <aside className='fourth-box flex'>
                <button className='box-button flex' type='submit'>
                    <img src={addUser} className='icon' alt='Icono boton agregar nuevo usuario' />
                    <p>Crear Nuevo Usuario</p>
                </button>
                <p onClick={() => onClose(false)}>Cancelar</p>
            </aside>
        </form>
    )
};

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <img src={downArrowWhite} alt="CustomArrow" />
        </components.DropdownIndicator>
    );
};

const DropdownIndicator2 = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <img src={downArrow} alt="CustomArrow" />
        </components.DropdownIndicator>
    );
};

export default AddUserForm;